module.exports = __webpack_public_path__ + "static/media/2_en.d115f81f.png";